import React from 'react';

// === DUMMY DATA GENERATOR FOR 100+ ITEMS ===
// Bhai, 100 items hath se likhne mein code bohot bada ho jata, isliye maine base categories banakar unhe expand kiya hai taaki demo mein literally 100 items dikhein.
const generateMenu = () => {
  const categories = [
    { name: "Soups & Salads", basePrice: 120, items: ["Tomato Dhaniya Shorba", "Hot & Sour Soup", "Sweet Corn Soup", "Manchow Soup", "Cream of Mushroom", "Green Salad", "Russian Salad", "Kachumber Salad", "Caesar Salad", "Greek Salad", "Lemon Coriander Soup", "Talumein Soup"] },
    { name: "Chinese Starters", basePrice: 180, items: ["Chilli Paneer Dry", "Veg Manchurian", "Crispy Corn", "Honey Chilli Potato", "Spring Rolls", "Mushroom Chilli", "Gobi Manchurian", "Veg Salt & Pepper", "Chilli Garlic Potato Bites", "Dragon Paneer", "Schezwan Veg Dry", "Crispy Lotus Stem"] },
    { name: "Tandoori Starters (Veg)", basePrice: 220, items: ["Paneer Tikka", "Malai Broccoli", "Tandoori Mushroom", "Hara Bhara Kebab", "Dahi Ke Sholay", "Afghani Chaap", "Achari Chaap", "Pudina Paneer Tikka", "Seekh Kebab Veg", "Tandoori Aloo", "Corn Kebab", "Soya Tikka Masala"] },
    { name: "Pizzas & Pastas", basePrice: 250, items: ["Margherita Pizza", "Farmhouse Pizza", "Peppy Paneer Pizza", "Mushroom Delight Pizza", "Spicy Veggie Pizza", "Arrabbiata Pasta", "Alfredo White Sauce", "Penne Pink Sauce", "Lasagna Veg", "Mac & Cheese", "Cheese Garlic Bread", "Stuffed Garlic Bread"] },
    { name: "Main Course (Indian)", basePrice: 240, items: ["Dal Makhani", "Dal Tadka", "Paneer Butter Masala", "Kadhai Paneer", "Shahi Paneer", "Mix Veg", "Malai Kofta", "Mushroom Do Pyaza", "Dum Aloo", "Bhindi Masala", "Chana Masala", "Navratan Korma", "Mutter Paneer", "Baingan Bharta"] },
    { name: "Breads & Rice", basePrice: 40, items: ["Tandoori Roti", "Butter Naan", "Garlic Naan", "Lachha Paratha", "Missi Roti", "Cheese Naan", "Pudina Paratha", "Steamed Rice", "Jeera Rice", "Veg Pulao", "Veg Biryani", "Hyderabadi Biryani", "Kashmiri Pulao", "Peas Pulao"] },
    { name: "Beverages", basePrice: 90, items: ["Fresh Lime Soda", "Cold Coffee", "Virgin Mojito", "Blue Lagoon", "Mango Shake", "Chocolate Shake", "Oreo Shake", "Masala Chai", "Filter Coffee", "Iced Tea", "Diet Coke", "Red Bull", "Bottled Water", "Fresh Watermelon Juice"] },
    { name: "Desserts", basePrice: 150, items: ["Gulab Jamun", "Rasmalai", "Hot Chocolate Fudge", "Brownie with Ice Cream", "Tutti Frutti Sundae", "Vanilla Ice Cream", "Chocolate Mud Pie", "Cheesecake", "Gajar Ka Halwa (Seasonal)", "Moong Dal Halwa", "Kulfi Falooda"] }
  ];

  return categories.map(cat => ({
    category: cat.name,
    // Creating realistic variations to hit the 100+ mark easily
    items: cat.items.map((item, idx) => ({
      name: item,
      price: `₹${cat.basePrice + (idx * 15)}`,
      desc: idx % 3 === 0 ? "Chef's special preparation." : "Freshly made to order with authentic spices."
    }))
  }));
};

const massiveMenuData = generateMenu();

const RestaurantBasic: React.FC = () => {
  return (
    // Red & Amber Foodie Theme
    <div className="min-h-screen bg-[#FFFDFB] text-zinc-900 font-sans scroll-smooth">
      
      {/* 1. NAVBAR */}
      <nav className="bg-white/90 backdrop-blur-md sticky top-0 z-50 shadow-sm border-b border-red-100">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-3xl text-red-600">🌶️</span>
            <span className="text-2xl font-black font-serif text-zinc-900 tracking-tight uppercase">
              Spice <span className="text-red-600">Route</span>
            </span>
          </div>
          
          <div className="hidden md:flex items-center gap-8 font-bold text-zinc-700 text-sm uppercase tracking-widest">
            <a href="#about" className="hover:text-red-600 transition">Our Story</a>
            <a href="#menu" className="hover:text-red-600 transition">Full Menu</a>
            <a href="#location" className="hover:text-red-600 transition">Location</a>
          </div>

          <a href="tel:+919876543210" className="bg-red-600 text-white px-7 py-3 rounded-full text-xs font-black uppercase tracking-widest hover:bg-red-700 transition shadow-lg shadow-red-600/30 flex items-center gap-2 animate-pulse">
            <span>📞</span> Order Now
          </a>
        </div>
      </nav>

      {/* 2. HERO SECTION (Massive Image Background) */}
      <header className="relative bg-zinc-950 py-32 lg:py-48 px-6 overflow-hidden">
        <div className="absolute inset-0 z-0">
          {/* Mouth watering food background */}
          <img 
            src="https://images.unsplash.com/photo-1555939594-58d7cb561ad1?q=80&w=1600&auto=format&fit=crop" 
            alt="Delicious Food" 
            className="w-full h-full object-cover opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-zinc-950/60 to-transparent"></div>
        </div>

        <div className="max-w-7xl mx-auto relative z-10 text-center flex flex-col items-center">
          <span className="inline-block bg-red-600 text-white px-5 py-2 rounded-full text-sm font-bold uppercase tracking-widest mb-6 shadow-xl shadow-red-600/20 border border-red-500">
            100+ Authentic Dishes
          </span>
          <h1 className="text-6xl md:text-8xl font-black font-serif text-white leading-tight drop-shadow-2xl">
            Taste The <br/> <span className="text-amber-500 italic font-medium">Extraordinary.</span>
          </h1>
          <p className="text-xl text-zinc-300 max-w-2xl mt-8 font-medium leading-relaxed drop-shadow-md">
            Skip the middleman and order directly from us. Experience the true flavors of our kitchen delivered hot to your doorstep, or dine-in for a royal treat.
          </p>
          <div className="flex flex-col sm:flex-row gap-5 pt-10">
            <a href="#menu" className="bg-red-600 text-white px-10 py-4 rounded-full font-black uppercase tracking-widest hover:bg-red-700 transition shadow-2xl shadow-red-600/40 text-sm">
              Explore 100+ Items
            </a>
          </div>
        </div>
      </header>

      {/* 3. ABOUT / CHEF'S SPECIAL (Adds length and premium feel) */}
      <section id="about" className="py-24 px-6 bg-amber-50 relative overflow-hidden">
        {/* Subtle background texture */}
        <div className="absolute inset-0 opacity-5 pointer-events-none" style={{ backgroundImage: 'radial-gradient(#b91c1c 1px, transparent 1px)', backgroundSize: '20px 20px' }}></div>
        
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div className="space-y-6">
              <span className="text-red-600 font-bold tracking-widest uppercase text-sm">The Spice Route Journey</span>
              <h2 className="text-4xl lg:text-5xl font-black font-serif text-zinc-900 leading-tight">Fresh Ingredients.<br/>Secret Recipes.</h2>
              <p className="text-lg text-zinc-600 leading-relaxed">
                We believe that good food brings people together. Our culinary team sources the freshest ingredients daily to craft dishes that not only fill your stomach but warm your soul. 
              </p>
              <div className="grid grid-cols-2 gap-6 pt-6">
                <div className="bg-white p-6 rounded-2xl shadow-sm border border-amber-100">
                  <span className="text-4xl mb-2 block">🛵</span>
                  <h4 className="font-bold text-zinc-900">Direct Delivery</h4>
                  <p className="text-sm text-zinc-500 mt-1">No hidden app fees. Order direct for the best prices.</p>
                </div>
                <div className="bg-white p-6 rounded-2xl shadow-sm border border-amber-100">
                  <span className="text-4xl mb-2 block">🌿</span>
                  <h4 className="font-bold text-zinc-900">100% Fresh</h4>
                  <p className="text-sm text-zinc-500 mt-1">Meals prepared strictly upon order confirmation.</p>
                </div>
              </div>
            </div>
            <div className="relative h-[500px] rounded-[2rem] overflow-hidden shadow-2xl border-8 border-white">
              <img src="https://img.freepik.com/premium-photo/professional-chef-preparing-food-restaurant-kitchen_605022-12143.jpg" alt="Chef preparing food" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </section>

      {/* 4. MASSIVE MENU SECTION (100+ Items Grid) */}
      <section id="menu" className="py-24 px-6 bg-[#FFFDFB]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-20 space-y-4">
            <span className="text-red-600 font-bold tracking-widest uppercase text-sm">Digital Menu</span>
            <h2 className="text-5xl lg:text-6xl font-black font-serif text-zinc-900">Our Full Menu</h2>
            <p className="text-zinc-500 text-lg">Browse our massive collection of culinary delights.</p>
          </div>

          <div className="space-y-20">
            {massiveMenuData.map((section, idx) => (
              <div key={idx} className="bg-white p-8 md:p-12 rounded-[2.5rem] shadow-xl shadow-zinc-200/50 border border-zinc-100">
                <div className="flex items-center gap-4 mb-10 pb-4 border-b-2 border-red-100">
                  <h3 className="text-3xl font-black font-serif text-zinc-900 uppercase tracking-wide">
                    {section.category}
                  </h3>
                  <span className="bg-amber-100 text-amber-800 text-xs font-bold px-3 py-1 rounded-full">
                    {section.items.length} Items
                  </span>
                </div>
                
                {/* 2 or 3 Column Grid for massive list */}
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-8">
                  {section.items.map((item, itemIdx) => (
                    <div key={itemIdx} className="flex justify-between items-start group border-b border-zinc-50 border-dashed pb-2">
                      <div className="pr-4">
                        <h4 className="text-base font-bold text-zinc-800 group-hover:text-red-600 transition">{item.name}</h4>
                        <p className="text-xs text-zinc-400 mt-1">{item.desc}</p>
                      </div>
                      <span className="text-base font-black text-red-700 whitespace-nowrap">{item.price}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Call to action after huge menu */}
          <div className="mt-24 text-center bg-zinc-900 p-12 md:p-16 rounded-[3rem] shadow-2xl relative overflow-hidden">
            <div className="absolute inset-0 opacity-20"><img src="https://images.unsplash.com/photo-1555396273-367ea4eb4db5?q=80&w=800&auto=format&fit=crop" className="w-full h-full object-cover" alt="bg"/></div>
            <div className="relative z-10 space-y-6">
              <h2 className="text-4xl md:text-5xl font-black font-serif text-white">Ready to satisfy your cravings?</h2>
              <p className="text-zinc-400 text-lg max-w-2xl mx-auto">Call us directly to place your order. Save on delivery app commissions and get faster service!</p>
              <a href="tel:+919876543210" className="inline-block mt-4 bg-red-600 text-white px-10 py-5 rounded-full font-black uppercase tracking-widest hover:bg-red-500 transition shadow-2xl shadow-red-600/50">
                📞 Call: +91 98765 43210
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* 5. LOCATION & TIMINGS */}
      <section id="location" className="py-24 px-6 bg-zinc-50 border-t border-zinc-200">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-16 items-center">
          
          <div className="order-2 md:order-1 h-[400px] bg-zinc-300 rounded-[2.5rem] overflow-hidden shadow-2xl border-8 border-white relative group">
            {/* Map Placeholder Image */}
            <img src="https://images.unsplash.com/photo-1524661135-423995f22d0b?q=80&w=800&auto=format&fit=crop" alt="Map" className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition duration-700" />
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
              <div className="bg-white/90 backdrop-blur-sm p-4 rounded-2xl shadow-xl text-center font-bold text-zinc-900 border border-zinc-200">
                <span className="text-3xl block mb-2 text-red-600">📍</span>
                Spice Route Cafe
              </div>
            </div>
          </div>

          <div className="order-1 md:order-2 space-y-10 pl-0 md:pl-8">
            <div>
              <span className="text-red-600 font-bold tracking-widest uppercase text-sm mb-2 block">Visit Us</span>
              <h2 className="text-5xl font-serif font-black text-zinc-900">Find Our Kitchen</h2>
            </div>

            <div className="space-y-8">
              <div className="flex gap-5 items-start p-6 bg-white rounded-2xl shadow-sm border border-zinc-100">
                <span className="text-4xl text-red-600">📍</span>
                <div>
                  <h4 className="font-bold text-zinc-900 text-xl mb-2">Location</h4>
                  <p className="text-zinc-600 leading-relaxed">Shop No. 42, Food Court Avenue,<br />Opposite Metro Station, Ghaziabad, UP 201002</p>
                </div>
              </div>

              <div className="flex gap-5 items-start p-6 bg-white rounded-2xl shadow-sm border border-zinc-100">
                <span className="text-4xl text-red-600">🕒</span>
                <div>
                  <h4 className="font-bold text-zinc-900 text-xl mb-2">Opening Hours</h4>
                  <p className="text-zinc-600 leading-relaxed">
                    Open All Days<br />
                    <span className="font-bold text-amber-600 text-lg mt-1 block">11:00 AM to 11:30 PM</span>
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* 6. EXPANDED MEGA FOOTER */}
     <footer className="w-full bg-white font-sans text-stone-800">
      
      {/* 1. AS SEEN IN (Brand Logos) */}
      <div className="py-16 text-center max-w-6xl mx-auto px-6">
        <h3 className="text-sm tracking-[0.2em] uppercase font-bold mb-10 text-stone-500">As Seen In</h3>
        
        {/* Placeholder Logos (Client ko yahan real logo images lagane ko bolna) */}
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 opacity-80 grayscale hover:grayscale-0 transition-all duration-500">
          <span className="text-3xl font-black tracking-tighter">SELF</span>
          <span className="text-2xl font-bold text-red-500 tracking-tight">BuzzFeed</span>
          <span className="text-3xl font-serif font-bold italic text-green-900">HUFFPOST</span>
          <span className="text-2xl font-sans font-light tracking-widest uppercase">Shape</span>
          <div className="flex flex-col items-center leading-none text-stone-900">
             <span className="text-[10px] font-bold tracking-widest">GOOD</span>
             <span className="text-[10px] font-bold tracking-widest">HOUSEKEEPING</span>
          </div>
          <span className="text-2xl font-bold tracking-widest">BRIT+CO</span>
        </div>
      </div>

      {/* 2. PEACH NAVIGATION BAND */}
      <div className="bg-[#FAEBE4] py-12 px-6 relative border-y border-[#f1dcd2]">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">
          
          {/* Cursive Logo (Image ki tarah lagne ke liye brush font style) */}
          <div className="text-6xl font-light text-stone-900 select-none cursor-pointer hover:opacity-70 transition" style={{ fontFamily: "'Brush Script MT', 'Cedarville Cursive', cursive" }}>
             the urban bite
          </div>
          
          {/* Main Links */}
          <div className="flex flex-wrap justify-center lg:justify-end gap-x-6 gap-y-5 text-[10px] font-bold uppercase tracking-[0.15em] text-stone-600">
            <a href="#" className="hover:text-stone-900 transition">Recipes</a>
            <a href="#" className="hover:text-stone-900 transition">Breakfast</a>
            <a href="#" className="hover:text-stone-900 transition">Lunch & Dinner</a>
            <a href="#" className="hover:text-stone-900 transition">Dessert</a>
            <a href="#" className="hover:text-stone-900 transition">Salad</a>
            <a href="#" className="hover:text-stone-900 transition">Snacks</a>
            <a href="#" className="hover:text-stone-900 transition">About</a>
            <a href="#" className="hover:text-stone-900 transition">Cookbook</a>
            <a href="#" className="hover:text-stone-900 transition">Contact</a>
          </div>

        </div>

        {/* Floating Action Button (Search Icon jaisa image mein hai) */}
        <button className="absolute -bottom-5 right-8 md:right-16 w-10 h-10 bg-[#C27A5B] text-white rounded-full flex items-center justify-center shadow-lg hover:bg-[#a56346] hover:scale-105 transition duration-300">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
        </button>
      </div>

      {/* 3. COPYRIGHT & SOCIAL */}
      <div className="py-10 px-6 bg-white">
        <div className="max-w-7xl mx-auto flex flex-col-reverse md:flex-row justify-between items-center gap-6">
          
          {/* Copyright Text */}
          <p className="text-[9px] sm:text-[10px] uppercase tracking-widest font-bold text-stone-400 text-center md:text-left">
            © {new Date().getFullYear()} THE URBAN BITE. ALL RIGHTS RESERVED. <a href="#" className="underline hover:text-stone-800 transition">PRIVACY POLICY</a> • POWERED BY <a href="#" className="underline hover:text-stone-800 transition">YOUR BRAND</a>.
          </p>
          
          {/* Social Icons (Premium Minimalist SVGs) */}
          <div className="flex items-center gap-4 text-stone-900">
            {/* Pinterest */}
            <a href="#" className="hover:opacity-60 transition">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.401.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.354-.629-2.758-1.379l-.749 2.848c-.269 1.045-1.004 2.352-1.498 3.146 1.123.345 2.306.535 3.55.535 6.607 0 11.985-5.365 11.985-11.987C23.97 5.367 18.624 0 12.017 0z"/></svg>
            </a>
            {/* Instagram */}
            <a href="#" className="hover:opacity-60 transition">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
            </a>
            {/* Facebook */}
            <a href="#" className="hover:opacity-60 transition">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.469h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.469h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
            </a>
            {/* TikTok */}
            <a href="#" className="hover:opacity-60 transition">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/></svg>
            </a>
          </div>
        </div>
        
        {/* Update Privacy Link */}
        <div className="text-center mt-6">
          <a href="#" className="text-[10px] font-bold text-stone-300 underline hover:text-stone-500 transition uppercase tracking-widest">Update Privacy Preferences</a>
        </div>
      </div>
      
    </footer>

    </div>
  );
};

export default RestaurantBasic;